import '../src/styles/reset.scss';
import '../src/styles/stylesApp.scss'

// COMPONENTS //
import Home from '../src/views/Home/Home'



function App() {
  return (
    <div className="app">
      <Home/>
    </div>
  );
}

export default App;
